import { useApi } from "@backstage/core";
import { useCallback, useEffect } from "react";
import { useAsyncFn } from "react-use";
import { githubApiRef } from "../api/GithubApi";
import { handleError } from "@internal/plugin-utilities";

export const useUserPullRequests = ({ handle }: { handle: string }) => {
  const api = useApi(githubApiRef);

  const getUserPullRequests = useCallback(async () => {
    try {
      return await api.getPullRequestsByUser(handle);
    } catch (err: any) {
      return handleError(err);
    }
  }, [api, handle]);

  const [state, fetchUserPullRequests] = useAsyncFn(
    () => getUserPullRequests(),
    []
  );

  useEffect(() => {
    fetchUserPullRequests();
  }, [fetchUserPullRequests]);

  return {
    loading: state.loading,
    error: state.error,
    results: state?.value?.data,
    fetchUserPullRequests,
  };
};
